module.exports = __webpack_public_path__ + "static/media/tommy0.83053464.svg";